
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/private-jet",
      function () {
        return require("private-next-pages/investments/private-jet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/private-jet"])
      });
    }
  